module.exports = __webpack_public_path__ + "img/create.55662228.svg";